import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import classNames from 'classnames';
import CloseIcon from '@material-ui/icons/Close';

function DashboardCard({
  btnUrl,
  customBtn = null,
  className,
  children,
  fixedHeight = false,
  footer,
  plusBtnAriaLabel = 'Add',
  size,
  title,
  closeIcon,
  onClose,
  showInfo,
}) {
  const containerClassName = classNames({
    'dashboard-card': true,
    [className]: className,
    [size]: size === 'short' || size === 'drawer',
  });

  const contentClassName = classNames({
    'dashboard-card-content': true,
    'fixed-height': fixedHeight,
  });

  const closeButtonEl = useRef(null);

  return (
    <div className={containerClassName}>
      <div className="dashboard-card-header">
        {typeof title === 'string' ? (
          <h2 className="card-title" tabIndex={0}>
            {title}
          </h2>
        ) : (
          <div style={{ minWidth: '20%', display: showInfo ? 'inherit' : '' }} className="card-title">
            {title}
          </div>
        )}
        {closeIcon && (
          <button
            aria-label="close"
            className="dashboard-card-header-close-icon"
            ref={closeButtonEl}
            onClick={() => {
              onClose && onClose();
            }}>
            <CloseIcon />
          </button>
        )}

        {btnUrl && (
          <Link to={btnUrl} aria-label={plusBtnAriaLabel}>
            <AddIcon className="dashboard-card-header-icon-button" />
          </Link>
        )}
        {customBtn}
      </div>
      <div className={contentClassName}>{children}</div>
      {footer && <div className="dashboard-card-footer">{footer}</div>}
    </div>
  );
}

export default DashboardCard;
